import { createGlobalStyle } from 'styled-components';
export const lightTheme = {
  colors: {
    background: '#f0f2f5',
    card: '#ffffff',
    text: '#141414',
    textSecondary: '#fff',
    primary: '#f5222d',
    shadow: 'rgba(0,0,0,0.18)',
    lineColor: '#8c8c8c',
    buttonBackground: '#e0e0e0',
    buttonText: '#141414',
    buttonTextActive: '#ffffff',
  },
  typography: {
    fontFamily: "'Montserrat', sans-serif",
    h1: { size: '2.5rem', weight: 700 },
    h2: { size: '2rem', weight: 600 },
    h3: { size: '1.75rem', weight: 600 },
    body: { size: '1rem', weight: 400 },
    small: { size: '0.875rem', weight: 400 },
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px'
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px'
  },
  zIndex: {
    dropdown: 10,
    modal: 999,
    overlay: 1000
  },
  shadows: {
    sm: '0 2px 6px rgba(0,0,0,0.12)',
    md: '0 4px 12px rgba(0,0,0,0.18)',
    lg: '0 8px 24px rgba(0,0,0,0.22)'
  },
  status: {
    success: '#4caf50',
    error: '#f44336',
    warning: '#ff9800'
  }
};

export const darkTheme = {
  colors: {
    background: '#141414',
    card: '#2a2a2a',
    text: '#fafafa',
    textSecondary: '#fff',
    primary: 'oklch(63.7% 0.237 25.331)',
    shadow: 'rgba(0, 0, 0, 0.5)',
    lineColor: '#555555',
    buttonBackground: '#4a4a4a',
    buttonText: '#fafafa',
    buttonTextActive: '#ffffff',
  },
  typography: {
    fontFamily: "'Montserrat', sans-serif",
    h1: { size: '2.5rem', weight: 700 },
    h2: { size: '2rem', weight: 600 },
    h3: { size: '1.75rem', weight: 600 },
    body: { size: '1rem', weight: 400 },
    small: { size: '0.875rem', weight: 400 },
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px'
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px'
  },
  zIndex: {
    dropdown: 10,
    modal: 999,
    overlay: 1000
  },
  shadows: {
    sm: '0 2px 6px rgba(0,0,0,0.35)',
    md: '0 4px 12px rgba(0,0,0,0.45)',
    lg: '0 8px 24px rgba(0,0,0,0.55)'
  },
  status: {
    success: '#4caf50',
    error: '#f44336',
    warning: '#ff9800'
  }
};
export const GlobalStyles = createGlobalStyle`
    body {
    color: ${({ theme }) => theme.colors.text};
    background-color: ${({ theme }) => theme.colors.background};
    overflow-x: hidden;
    margin: 0;
    font-family: ${({ theme }) => theme.typography.fontFamily};
  }

  select {
    background-color: ${({ theme }) => theme.colors.card};
    color: ${({ theme }) => theme.colors.text};
    border: 1px solid ${({ theme }) => theme.colors.lineColor};
    border-radius: ${({ theme }) => theme.borderRadius.md};
    padding: 0.4rem 0.6rem;
    font-family: ${({ theme }) => theme.typography.fontFamily};
    font-size: 0.9rem;
    width: 100%;
    cursor: pointer;
    color-scheme: ${({ theme }) => theme.colors.background === "#ffffff" ? "light" : "dark"};
  }

  select:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
  }

  select option {
    background-color: ${({ theme }) => theme.colors.card};
    color: ${({ theme }) => theme.colors.text};
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }
`;
